import { render, staticRenderFns } from "./peopleContacts.vue?vue&type=template&id=2aad5d70&scoped=true"
import script from "./peopleContacts.vue?vue&type=script&lang=js"
export * from "./peopleContacts.vue?vue&type=script&lang=js"
import style0 from "./peopleContacts.vue?vue&type=style&index=0&id=2aad5d70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aad5d70",
  null
  
)

export default component.exports